import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetInvoicesParams,
    GetInvoicesResponse,
    InvoicesExcelResponse,
    KaspiReportParams,
    KaspiReportResponse,
} from '@/new-services/types/cms'

type ApiGetInvoicesResponse = Promise<AxiosResponse<GetInvoicesResponse>>
type ApiInvoicesExcelResponse = Promise<AxiosResponse<InvoicesExcelResponse>>
type ApiKaspiReportResponse = Promise<AxiosResponse<KaspiReportResponse>>

export function getInvoices(params: GetInvoicesParams): ApiGetInvoicesResponse {
    return http.get('/cabinet/api/cms/invoices', { params })
}

export function downloadExcel(params: GetInvoicesParams): ApiInvoicesExcelResponse {
    return http.get('/cabinet/api/cms/invoices/export', { params, responseType: 'blob' })
}
export function downloadKaspiReport(params: KaspiReportParams): ApiKaspiReportResponse {
    return http.get('/cabinet/api/cms/invoices/kaspi-export', { params, responseType: 'blob' })
}

export default {
    getInvoices,
    downloadExcel,
    downloadKaspiReport,
}
